export enum TenantTypeEnum {
  'Italy' = 1,
  'KappaFrance' = 2,
  'KappaSpain' = 3,
  'KwayFrance' = 4
}
